import { FC, MutableRefObject, useRef, useState, useEffect } from 'react';
import { getLabel } from '../autocompleteUtils';
import { autocomplete } from '../searchAutocomplete.api';
import { AutocompleteItemType } from '../searchAutocomplete.types';
import { useIsMounted } from '../../../../../components/hooks/useIsMounted';

type Props = {
  query: string;
  children: (data: { items: Array<AutocompleteItemType> }) => ReturnType<FC>;
};

export const SearchAutocompleteFetcher: FC<Props> = ({ query, children }) => {
  const { getIsMounted } = useIsMounted();

  /**
   * Prevent previous autocomplete requests to override new ones
   */
  const requestIndex: MutableRefObject<number> = useRef(0);
  const lastResponseIndex: MutableRefObject<number> = useRef(0);

  const [items, setItems] = useState<Array<AutocompleteItemType>>([]);

  useEffect(() => {
    requestIndex.current += 1;
    autocomplete(query, requestIndex.current)
      .then((response) => {
        const responseIndex = response.data.index;

        if (responseIndex < lastResponseIndex.current) {
          return;
        }
        lastResponseIndex.current = responseIndex;

        const newItems = response.data.completions.map((item) => ({
          ...item,
          label: getLabel(item),
        }));
        if (getIsMounted()) {
          setItems(newItems);
        }
      })
      .catch((error) => {
        console.error(error);
        if (getIsMounted()) {
          setItems([]);
        }
      });
  }, [query]);

  return children({ items });
};
